module.exports = __webpack_public_path__ + "img/barco.dfd10199.png";